var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.7 37.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-C7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.85,0A18.85,18.85,0,1,1,0,18.85,18.86,18.86,0,0,1,18.85,0Z",
    transform: "translate(0 0)",
    fill: "#ef742c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57,15.83,18,28.55s.44,1,1.69-.44,9.77-11.87,9.77-11.87a1.89,1.89,0,0,0-.08-1.57c-.44-.73-4-5.84-4-5.84h-13L8,14.46S7.31,15.18,7.57,15.83Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.87 15.63 18.52 28.87 24.62 15.55 18.89 8.82 15.87 12.24 12.87 15.63",
    fill: "#fffac9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57,15.83,18,28.55a.58.58,0,0,0,.49.32L12.87,15.63l3-3.39L12.41,8.83h0L8,14.46s-.72.72-.47,1.37Z",
    transform: "translate(0 0)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72,28.11C21,26.7,29.49,16.24,29.49,16.24a1.89,1.89,0,0,0-.08-1.57c-.42-.69-3.66-5.33-4-5.8l-3.48,3.54,2.69,3.14-6.1,13.32c.26,0,.66-.15,1.2-.76Z",
    transform: "translate(0 0)",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,15.47l2.86-3.23L12.41,8.83h0L8,14.46a1.91,1.91,0,0,0-.52,1Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.55,15.47h5.08a1.45,1.45,0,0,0-.22-.8c-.42-.69-3.66-5.32-4-5.8l-3.48,3.54,2.62,3.06Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.21 15.24 24.36 15.24 21.94 12.4 18.89 8.82 15.87 12.24 13.21 15.24",
    fill: "#ccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.52 28.87 24.62 15.55 24.55 15.47 24.36 15.24 13.21 15.24 13.01 15.47 12.87 15.63 18.52 28.87",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC7);
export default __webpack_public_path__ + "static/media/C7.b7e48de62363e3b54b8ee6c33ce108af.svg";
export { ForwardRef as ReactComponent };